import { render, staticRenderFns } from "./musicSrc.vue?vue&type=template&id=5d8626c0&scoped=true"
import script from "./musicSrc.vue?vue&type=script&lang=js"
export * from "./musicSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8626c0",
  null
  
)

export default component.exports